import styled, { css } from 'styled-components';
import DatePicker from '../datePicker/datePicker';

export const SDatePicker = styled(DatePicker as any)(
  () => css`
    max-width: 80px;
    border: none;
    height: 21px;
    margin-right: 5px;
    display: flex;
    input {
      background: #f2f4f7;
      display: flex;
      border: 1px solid #f2f4f7;
      margin: 0;
      text-align: center;
      padding: 3px;
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 21px;
      cursor: pointer;
      color: #002169;
    }
    .inputInnerWrap {
      border-width: 0;
      border: none;
    }
  `
);

export const SDateContainer = styled.div(
  () => css`
    display: flex;
    flex-direction: row;
    width: 100%;
  `
);
